import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Model } from 'libx';
import { observable } from 'mobx';
var UserData = (_class = /*#__PURE__*/function (_Model) {
  function UserData() {
    var _this;
    _classCallCheck(this, UserData);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, UserData, [].concat(args));
    _initializerDefineProperty(_this, "userPublicId", _descriptor, _this);
    _initializerDefineProperty(_this, "userDataType", _descriptor2, _this);
    _initializerDefineProperty(_this, "givenName", _descriptor3, _this);
    _initializerDefineProperty(_this, "familyName", _descriptor4, _this);
    _initializerDefineProperty(_this, "email", _descriptor5, _this);
    _initializerDefineProperty(_this, "phone", _descriptor6, _this);
    _initializerDefineProperty(_this, "workspaceSlugs", _descriptor7, _this);
    /**
     * The user's job capacity, 0 means unlimited.
     */
    _initializerDefineProperty(_this, "jobCapacity", _descriptor8, _this);
    return _this;
  }
  _inherits(UserData, _Model);
  return _createClass(UserData, [{
    key: "parse",
    value: function parse(data) {
      return {
        userPublicId: data.user_public_id,
        userDataType: data.type,
        givenName: data.given_name,
        familyName: data.family_name,
        email: data.email,
        phone: data.phone,
        workspaceSlugs: data.workspace_slugs,
        jobCapacity: data.job_capacity
      };
    }
  }]);
}(Model), _descriptor = _applyDecoratedDescriptor(_class.prototype, "userPublicId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "userDataType", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "givenName", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "familyName", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "email", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "phone", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "workspaceSlugs", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "jobCapacity", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _class);
export { UserData as default };
//# sourceMappingURL=UserData.js.map
